import React, { useEffect, useState } from "react";
import { get } from "../../../../modules/get.js";
import { showError } from "../../../client/gallery/scripts/showError.js";
import Footer from "../../../client/gallery/components/footer/footer.js";
import ProcessingAnimation from "../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import ImageGallery from "../ImageGallery/ImageGallery.js";
import Nav from "../Nav/Nav.js";
import { updateStyle } from "../../../client/gallery/scripts/useStyle.js";
import "./style.css";
export default function Container(props) {
    const [collection, setCollection] = useState(undefined);
    const [openedTab, setOpenedTab] = useState(-1);
    useEffect(() => {
        get("/api/public/collectionClient/collection").then((res) => {
            if (res.status !== 200)
                return showError("Nie udało się wczytać galerii");
            console.log(res.collection);
            setCollection(res.collection);
            updateStyle(res.collection.appearance.style, "default");
        });
    }, []);
    if (!collection)
        return React.createElement(ProcessingAnimation, null);
    return (React.createElement("div", { className: "collection-main-container" },
        React.createElement(Nav, { collection: collection, openedTab: openedTab, onTabOpen: setOpenedTab }),
        openedTab === -1 ?
            React.createElement(ImageGallery, { allowedImages: collection.allowedImages, clientMessage: collection.content.firstMessage, withDownloadManyButton: collection.content.allowFullDownload ?
                    collection.categories.flatMap((category) => category.images.map((img) => img.name))
                    : undefined })
            : React.createElement(React.Fragment, null,
                React.createElement(ImageGallery, { allowedImages: collection.categories[openedTab].images, clientMessage: collection.categories[openedTab].description })),
        React.createElement(Footer, { merchantFooter: collection.content.footer })));
}
